// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export enum CheckCameraResolutionFeedback {
  Succeeded,
  Failed,
  ResolutionNotSupported,
  PermissionDenied,
}

export default CheckCameraResolutionFeedback;
